import { ObjectFieldsChecker } from "../../../../../../../tools/ObjectFieldsChecker";
import { GuestShortDto } from "../../../../../../networking/data/responses/marketplace/buildings/GuestShortDto";

export class GuestShort {
    public readonly name: string;

    public constructor(dto: GuestShortDto) {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "name"
        ]);
        this.name = dto.name;
    }
}
